export default __webpack_public_path__ + "static/media/back-sipa.da56c2bd.png";